import e from"./createElements.js";const t=(t=[],o,r,s)=>e(t,o,{...r,oneClick:!0},s);export{t as default};
//# sourceMappingURL=createStoredElements.js.map
